import { render, staticRenderFns } from "./FeatureScreen.vue?vue&type=template&id=2911a6e6&"
import script from "./FeatureScreen.vue?vue&type=script&lang=js&"
export * from "./FeatureScreen.vue?vue&type=script&lang=js&"
import style0 from "./FeatureScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CdnImage: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Image/CdnImage.vue').default,Wrapper: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Layout/Wrapper.vue').default,Container: require('/home/runner/work/jobs/jobs/node_modules/spoferan-ui/src/components/Layout/Container.vue').default})
